import { createContext, useContext } from 'react';
import { User, UserAthlete } from '@type/db-types';

export interface UserContextValues {
    loading: boolean;
    user: User | undefined | null;
    athletes: UserAthlete[];
    refresh: () => void;
}

export const UserContext = createContext<UserContextValues>({
    loading: true,
    user: undefined,
    athletes: [],
    refresh: () => {},
});

// Access user context values and functions
const useUser = () => {
    const ctx = useContext(UserContext);

    if (!ctx) console.error('useUser called outside of UserProvider Context');

    return ctx;
};

export default useUser;
